import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { accountGroupsStateForUsernameSelector } from '../account-group-selectors';

import * as Api from '../../api/api';

export const loadAccountGroups = (username?: string) =>
  createGenericDispatcher<AccountGroup[]>({
    name: 'LOAD_ACCOUNT_GROUPS',
    loadFunction: () => Api.get(`/account-group${username ? `?username=${username}` : ''}`),
    args: { username },
    shouldExecuteSelector: (state: any) =>
      accountGroupsStateForUsernameSelector(state, username ?? 'admin'),
  });
